module.exports = __webpack_public_path__ + "img/gallery-image-2.06403ea4.png";